import { Component } from '@angular/core';
import { DsButtonVariants, DsInputModule, DsModalService, DsSearchBarModule, Icons } from '@levelaccess/design-system';

import { NotificationService } from '@client/app/services/notification.service';
import { SecurityGroupService } from '@client/app/services/security-group.service';
import { SecurityEntityLevel } from '@shared/constants/security-group';
import { AbstractUsersListComponent } from '../../../../components/abstract-users-list/abstract-users-list.component';
import { AsyncReportService } from '../../../../services/async-report.service';
import { LoadErrorHandler } from '../../../../services/load-error-handler';
import { SecurityUserService } from '../../../../services/security-user.service';
import { UserAclService } from '../../../../services/user-acl.service';
import { UserService } from '../../../../services/user.service';
import { SharedModule } from '../../../../shared/shared.module';
import { TranslateService } from '../../../../translate/translate.service';

@Component({
  imports: [SharedModule, DsSearchBarModule, DsInputModule],
  selector: 'app-workspace-users',
  templateUrl: './workspace-users.component.html',
  styleUrls: ['./workspace-users.component.scss'],
  providers: [AsyncReportService],
  standalone: true,
})
export class WorkspaceUsersComponent extends AbstractUsersListComponent {
  protected readonly Icons: typeof Icons = Icons;
  protected readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;

  protected override entityLevel: SecurityEntityLevel = SecurityEntityLevel.workspace;
  protected override errorTranslationKey: string = 'workspace_details_users_loading_error';
  protected override emptyStateTranslationKey: string = 'workspace_details_users_empty_state_title';
  protected override captionTranslationKey: string = 'workspace_details_users_table_caption';

  constructor(
    userService: UserService,
    securityUserService: SecurityUserService,
    loadErrorHandler: LoadErrorHandler,
    translateService: TranslateService,
    securityGroupService: SecurityGroupService,
    notificationService: NotificationService,
    dsModalService: DsModalService,
    userAclService: UserAclService,
    asyncReportService: AsyncReportService,
  ) {
    super(
      userService,
      securityUserService,
      loadErrorHandler,
      translateService,
      securityGroupService,
      notificationService,
      dsModalService,
      userAclService,
      asyncReportService,
    );
  }

  handleGroupFilterChange(groupId: string | null): void {
    this.groupFilter$.next(groupId);
    this.page$.next(1);
  }
}
